module.exports = __webpack_public_path__ + "img/006.c39427cb.jpg";